// extracted by mini-css-extract-plugin
export default {"body":"BookingRebook_modal_body__MHzF8"};